export function capitalizeWords(str) {
    if (!str || str.length === 0)
        return str
    return str.replace(/[A-zÀ-ú]\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
}